import { combineReducers } from 'redux';

// Reducers Import
import { darkModeReducer } from './reducers/darkmode.reducer';
import { windowSizeReducer } from './reducers/windowsize.reducer';

export const rootReducer = combineReducers({
    darkMode: darkModeReducer,
    dataSize: windowSizeReducer
});

export type RootState = ReturnType<typeof rootReducer>;